import { createFileRoute } from '@tanstack/react-router'

// Intentionally empty: `/project/$projectId` is the bare plan list, and the
// list itself is rendered by the layout route (`_plans/route.tsx`) so that the
// modal child routes can layer on top of it.
export const Route = createFileRoute(
  '/_authenticated/project/$projectId/_plans/'
)({
  component: () => null
})
